import { ReactNode } from "react"

import { CSS, styled } from "@/stitches"
import { Separator as BaseSeparator } from "@/ui/separator"
import { Stack } from "@/ui/stack"

export function Root({ children, css }: { children?: ReactNode; css?: CSS }) {
  return (
    <Stack
      direction={{ "@initial": "column", "@md": "row" }}
      align={{ "@initial": "stretch", "@md": "center" }}
      justify="between"
      css={css}
      rowGap={6}
      wrap
    >
      {children}
    </Stack>
  )
}

export const Left = styled("div")

export const Right = styled(Stack, {
  defaultVariants: {
    gap: 4,
    align: "center",
    wrap: true,
  },
})

export function Separator() {
  return (
    <BaseSeparator
      orientation="vertical"
      css={{
        height: "1.5em",
        display: "none",
        "@md": { display: "block" },
      }}
    />
  )
}
